import { mapGetters } from "vuex";

export const authority_level = {
  computed: {
    ...mapGetters(["userData", "table_user_group", "table_user_authority"]),
  },
  methods: {    
    /**
     * 메모리에 있는 사용자/그룹/권한 정보들을 기반으로, 현재 메뉴의 권한 정보를 가져옴
     * @param {user_authority 테이블에 정의된 메뉴 이름} menuName 
     * @returns '0' - 권한없음 / '1' - 읽기 / '2' - 읽기&쓰기
     */
    getMenuLevel(menuName) {
      let auth_item = this.table_user_authority.find(item => item.name === menuName);
      let group = this.table_user_group.find(item => item.id === this.userData.user_group_id);
      if (auth_item && group) {
        if (group.super_group_tag === 'Y') {
          return 2;
        }
        let group_auth_item = group.authorities.find(
          item => item.user_authority_id === auth_item.id
        );
        return group_auth_item? group_auth_item.level: 0;
      }
      return 0;
    },
    isWriteLevel(menuName) {
      return this.getMenuLevel(menuName) === 2;
    }
  },
}